module.exports = __webpack_public_path__ + "static/media/facebook.268c6b12.png";